import { AxiosResponse } from 'axios'
import ApiService from '@/plugins/api-plugin/services/api.service'
import { ManagementMappingEntryDao, SupportScheduleDao } from '@/interfaces/support/Support.dao'

export default class SupportService extends ApiService {
    async getSupportSchedule(): Promise<SupportScheduleDao | null> {
        return this.request<undefined, SupportScheduleDao>(
            'GET',
            '/support/schedule',
            undefined,
            undefined,
            undefined,
            'getSupportSchedule',
        ).catch(() => null)
    }

    async getManagementMapping(): Promise<ManagementMappingEntryDao[] | null> {
        return this.request<undefined, ManagementMappingEntryDao[]>(
            'GET',
            '/support/management-mapping',
            undefined,
            undefined,
            undefined,
            'getManagementMapping',
        ).catch(() => null)
    }

    async getReleaseNotesPdf(): Promise<AxiosResponse | null> {
        return this.request<undefined, AxiosResponse>(
            'GET',
            '/support/release-notes',
            undefined,
            undefined,
            'blob',
            'getReleaseNotesPdf',
        ).catch(() => null)
    }
}
